export enum TicketPriority {
  LOW = 0,
  NORMAL = 1,
  MEDIUM = 2,
  URGENT = 3,
  CRITICAL = 4,
}
